import React from 'react';
import PropTypes from 'prop-types';
import SingleCollapse from './SingleCollapse';

SingleCollapse.defaultProps = {
  type: 'table'
};
SingleCollapse.propTypes = {
  /** 要展示的类型 */
  data: PropTypes.string
};

export default SingleCollapse;
